module.exports = __webpack_public_path__ + "img/homeGoodstitle.793684eb.png";